import { ReactNode } from 'react';

import KeyGroupContext, { KeyGroupContextValue } from './keyGroupContext';

const KeyGroupProvider = ({
	value,
	children,
}: {
	value: KeyGroupContextValue;
	children: ReactNode;
}) => {
	return <KeyGroupContext value={value}>{children}</KeyGroupContext>;
};

export default KeyGroupProvider;
